import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';

i18n
  // Use the HttpApi backend to load translations from your /public folder
  .use(HttpApi)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // Initialize i18next
  .init({
    // Languages we support
    supportedLngs: ['en', 'sw'],
    
    // Default language
    fallbackLng: 'en',
    
    // Debugging logs in the browser console
    debug: true,

    // Options for language detection
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['cookie'],
    },

    // Options for the backend
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },

    // Options for react-i18next
    react: {
      // UPDATED: This is the key change.
      // This tells our components to wait for translations to load before rendering.
      useSuspense: true,
    },
  });

export default i18n;
